import React from 'react';
import { useConnect } from '@lore/query-connect';
import { tags_educator, user_networkId } from '../../../../utils/query-helpers';

export default function useSchools(network, schoolStart, schoolEnd, extra = {}, eager = {}) {
  return useConnect('site.find', {
    where: {
      eager: {
        $where: {
          // createdAt: {
          //   $lte: schoolEnd,
          //   $gte: schoolStart
          // },
          users: {
            $where: {
              ...tags_educator(),
              // 'networks.id': network?.id
              networkId: network?.id,
              createdAt: {
                $lte: schoolEnd,
                $gte: schoolStart
              }
            },
            $having: {
              count: {
                $gte: 1
              }
            }
          },
          ...extra
        },
        $eager: eager
      },
    },
    pagination: {
      pageSize: 1
    }
  });
}
